import * as React from 'react';
import { styled  } from '@mui/material/styles';
import { Navigate, useNavigate} from 'react-router-dom'
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';

import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';

import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import NotificationsIcon from '@mui/icons-material/Notifications';
import {  listItems } from './menu';
import {Outlet  } from 'react-router-dom'

import Footer from '../components/Footer.js'
import MiniLogo from '../components/MiniLogo.js'
import Hidden from '@mui/material/Hidden';
import { signOut  } from "firebase/auth";
import Logo from '../components/Logo.js'
import Loading from '../main-component/Loading.js';
import { app } from '../config/app.js';


// la larghezza della barra espansa
const drawerWidth = 240;
const sizeLimit=960;
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({

  width: ((window.innerWidth > sizeLimit) ? `calc(100% - 70px)` : '100%'),
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));
function MobileDrawer(props) {
  const toggleDrawer=props.toggleDrawer;
  const state=props.state;
  const setState=props.setState;
  const user=props.user;
  const setUser=props.setUser;
  const auth=props.auth;
  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >  
    <Box display="flex"
      alignItems="center"
      justifyContent="center" sx={{mb:2, mt:2} }><Logo sx={{align:"center"}} width={180} /></Box>
    {/*mainListItems*/}
    {listItems(function() {
                 signOut(auth).then (() => { setUser(null); })
            },app.ruoli[user.db.ruolo])}</Box>
  );

  const anchor='left';
  return (
    <div>
      {
       
       ['left'].map((anchor) => (
        <React.Fragment key={anchor}>
        
          <MuiDrawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </MuiDrawer>
        </React.Fragment>
        ))}
    </div>
  );
}
function DesktopDrawer(props) {
  /* è la sidebar a sinistra che fa parte del layout, non quella che appare sopra*/
  const open=props.open;
  const setOpen=props.setOpen;
  const setUser=props.setUser;
  const user=props.user;
  const auth=props.auth;
  const toggleDrawer = props.toggleDrawer;
  return(
          <Drawer variant="permanent" open={open}>
          <Toolbar
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              px: [1],
            }}
          >
           {
             open  ?  <><Logo height={50} /><IconButton onClick={toggleDrawer}>
              <ChevronLeftIcon />
            </IconButton></>:<> <MiniLogo  height={30} /><IconButton onClick={toggleDrawer}>
              <ChevronRightIcon />
            </IconButton></> 
            }
            
          </Toolbar>
          <Divider />
          <List component="nav">
            {listItems(function() {
                 signOut(auth).then (() => { setUser(null); })
            },app.ruoli[user.db.ruolo])}
      
          </List>
        </Drawer>);
}
const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: ((window.innerWidth > sizeLimit) ? theme.spacing(7) : 0),
        
        [theme.breakpoints.up('sm')]: {
          width: ((window.innerWidth > sizeLimit) ? theme.spacing(9 ) : 0),
        },
      }),
    },
  }),
);


export default function MainLayout(props) {
  const [openMenuDesktop, setOpenMenuDesktop] = React.useState(window.innerWidth > sizeLimit);
  const navigate = useNavigate();
  //const [openMenuDesktop, setOpenMenuDesktop] = React.useState(true);
  const toggleDesktopDrawer = () => {
    setOpenMenuDesktop(!openMenuDesktop);
  };
  const [stateMenuMobile, setStateMenuMobile] = React.useState({
   
    left: false
  });

  const toggleMobileDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setStateMenuMobile({ ...stateMenuMobile, [anchor]: open });
  };
  
  const user=props.user;
  //console.log("Aperto MainLayout con utente ",user)
  const setUser=props.setUser;
  
  const auth=props.auth;
  const anchor="left";
  React.useEffect(() => {
    const handleBack = (event) => {
      // Puoi aggiungere logica personalizzata qui, ad esempio:
      // navigare a una pagina diversa o chiedere conferma all'utente
   //   if (window.confirm('Sei sicuro di voler andare indietro?')) {
        navigate(-1); // Torna alla pagina precedente
   //   }
      event.preventDefault();
    };

    // Aggiungi un listener per l'evento di navigazione
    window.addEventListener('popstate', handleBack);

    return () => {
      // Rimuovi il listener quando il componente si smonta
      window.removeEventListener('popstate', handleBack);
    };
  }, [navigate]);
  return (
    <>
      {user === "loading" ? 
      <Loading /> :
      !user || !user.db ? 
      <Navigate to="/login" replace={true} /> :
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="absolute" open={openMenuDesktop}>
          <Toolbar
            sx={{
              pr: '24px', // keep right padding when drawer closed
            }}
          >
            <Hidden mdUp>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleMobileDrawer("left",true)}
              sx={{
                ...(stateMenuMobile["left"] && { display: 'none' }),
              }}
            >
            <MenuIcon />
          </IconButton></Hidden>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1 }}
            >
              <span title={user.uid} >{user.db.nome} {user.db.cognome}</span>
            </Typography>
          </Toolbar>
        </AppBar>
      <Hidden mdUp>
      <MobileDrawer auth={auth} setUser={setUser} user={user} state={stateMenuMobile} setState={setStateMenuMobile} toggleDrawer={toggleMobileDrawer}/>
      </Hidden>
      <Hidden smDown>
        
      <DesktopDrawer auth={auth} setUser={setUser} user={user}  open={openMenuDesktop} setOpen={setOpenMenuDesktop} toggleDrawer={toggleDesktopDrawer} />
      </Hidden>
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Toolbar />
          <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
           
            <Outlet />
            
          </Container>
        </Box>
      </Box>
    }</>
  );
}
